/**
 *
 * @module configurationClientEndpoint
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef ConfigurationClientEndpoint
 * @type {Object}
 *
 * @property {String} configuration
 *
 */

/**
 *
 * @enum
 * @type {ConfigurationClientEndpoint}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    configuration: null
});



// WEBPACK FOOTER //
// ./src/services/configuration/configurationClientEndpoint.js